export default __webpack_public_path__ + "static/media/Lidholt.311bd39f.png";